import { get } from './utils';

const retrieve_schedule = async (
    callback: ((data: any) => void) | null = null
): Promise<void> => {
    const path = '/schedule/retrieve';
    const result = await get(path);
    console.debug('retrieve_schedule', result?.data);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

export { retrieve_schedule };
